<template>
  <div class="container">
    <ul class="steps has-content-centered">
      <li class="steps-segment" :class="{ 'is-active': isActive('1') }">
        <a class="steps-marker"></a>
        <div class="steps-content">
          <p class="is-4">Step 1</p>
          <p>Create Customer's Profile and Contact Information</p>
        </div>
      </li>
      <li class="steps-segment" :class="{ 'is-active': isActive('2') }">
        <a class="steps-marker"></a>
        <div class="steps-content">
          <p class="is-4">Step 2</p>
          <p>Verify a form of contact for the Customer</p>
        </div>
      </li>
      <li class="steps-segment" :class="{ 'is-active': isActive('3') }">
        <a class="steps-marker"></a>
        <div class="steps-content">
          <p class="is-4">Step 3</p>
          <p>Create Customer's Location</p>
        </div>
      </li>
    </ul>

    <div :is="stepComponent" :customer-id="customerId"></div>
  </div>
</template>

<script>
export default {
  name: 'CreateCustomer',

  props: {
    step: {
      required: false
    },

    customerId: {
      required: false
    }
  },

  methods: {
    isActive (step) {
      if (step !== this.step) {
        if (this.step) {
          return false
        } else {
          return step === '1'
        }
      } else {
        return true
      }
    }
  },

  computed: {
    stepComponent () {
      switch (this.step) {
        case '2':
          return require('./CreateSteps/Two.vue').default
        default:
          return require('./CreateSteps/One.vue').default
      }
    }
  }
}
</script>
